module.exports = __webpack_public_path__ + "img/flag_usa.31a8db4f.svg";